import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import rgba from 'polished/lib/color/rgba';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withTheme } from '@material-ui/core/styles';

import GradientIcon from 'components/GradientIcon';

import ArrowLeftIcon from 'mdi-material-ui/ArrowLeft';

const CircleArrowLeftIcon = withTheme()(styled(ArrowLeftIcon)`
  width: 40px;
  height: 40px;
  border: 2px solid ${props => props.theme.palette.secondary.contrastText};
  color: ${props => props.theme.palette.secondary.contrastText};
  padding: 6px;
  border-radius: 100%;
`);

const NavTabs = styled(({ maskColor, ...other }) => <Tabs {...other} />)`
  margin-top: 15px;
  margin-bottom: 15px;
  @media (min-width: 1200px) {
    margin-left: -30px;
    margin-right: -30px;
  }

  @media (max-width: 599px) {
    position: relative;
    &:after {
      content: '';
      display: block;
      width: 40px;
      background: linear-gradient(
        to right,
        ${props => rgba(props.maskColor, 0)} 0%,
        ${props => rgba(props.maskColor, 1)} 100%
      );
      position: absolute;
      right: 0;
      top: 0;
      bottom: 2px;
      pointer-events: none;
    }
  }
`;

const NavTab = withTheme()(styled(({ iconURL, color, ...other }) => (
  <Tab
    icon={
      other.icon || (
        <GradientIcon
          src={iconURL}
          fromColor={
            other.selected
              ? '#20d340'
              : other.theme.palette.secondary.contrastText
          }
          toColor={
            other.selected
              ? '#00d1ed'
              : other.theme.palette.secondary.contrastText
          }
          width="40px"
          height="40px"
        />
      )
    }
    disableRipple
    {...other}
  />
))`
  flex-grow: 1;
  padding-bottom: 10px;
  color: ${props => props.theme.palette.secondary.contrastText};
  font-size: 12px;
  @media (max-width: 768px) {
    font-size: 11px;
  }
`);

const HelpNav = ({
  items,
  showBack,
  activeID,
  backgroundColor = 'white',
  color
}) => (
  <NavTabs
    value={activeID}
    indicatorColor="primary"
    variant="scrollable"
    scrollButtons="auto"
    maskColor={backgroundColor}
  >
    {showBack && (
      <NavTab
        color={color}
        component={Link}
        icon={<CircleArrowLeftIcon />}
        label="Help Center"
        to="/help"
      />
    )}

    {items.map((item, idx) => (
      <NavTab
        component={Link}
        value={item.uid}
        label={item.title}
        to={item.slug}
        iconURL={item.icon.url}
        key={idx}
      />
    ))}
  </NavTabs>
);

HelpNav.propTypes = {
  items: PropTypes.array,
  showBack: PropTypes.bool,
  activeID: PropTypes.any
};

export default HelpNav;
